import React, { useState } from "react";

import { useDispatch, useSelector } from "react-redux";

import { FooterAction } from "@/components/organisms/FooterAction/index";
import { saveLeadData } from "@/redux/actions/vida";
import { StateMachine } from "@/utils/consts";
import history from "@/utils/history";
import helpers, { sendTagChain } from "@/utils/helpers";
import { useQuoteService } from "@/services/quote.service";
import { usePlansContext } from "../../context/PlansContext";
import { changeIndValidacion, showModalLoading } from "@/redux/actions/global";
import { useLeadsService } from "@/services/leads.service";
import { DetailPlanMobile } from "../../../shared/components/DetailPlanMobile";
import { CODE_VIDA_CT } from "@/utils/consts";
import { getProductOptions } from "@/utils/product";

export const SectionAction = ({
  graciasValidacionStep,
  nextStep,
  validateForm,
  analyticsDetailAction,
  suscripcionStep,
}) => {
  const [loading, setLoading] = useState(false);

  const idLead = useSelector((state) => state.vida.idLead);
  const leadData = useSelector((state) => state.vida.leadData);
  const maxAmountQuote = useSelector((state) => state.plans.maxAmountQuote);
  const { state } = useSelector((state) => state.global);
  const { planSelected, typeOfFinancing, currencyPlan } = useSelector((state) => state.plans);
  const isSuscriptionEnabled = useSelector((state) => state.vida.suscription.enabled);

  const {
    sumAssured,
    savingTime,
    returnPercentage,
    assuredFinancialEntity,
  } = planSelected || {};

  const dispatch = useDispatch();
  const { isLoadingData } = usePlansContext();
  const { sendLeads } = useLeadsService();
  const { selectQuoteVe } = useQuoteService();

  const { digitalDataProductName, productName } = getProductOptions();

  const onHandleClick = async () => {
    const isValid = await validateForm?.();
    if (!isValid) return;

    const leadToSend = {
      ...leadData,
      idLead,
      bancoEndosatario: assuredFinancialEntity?.name,
      sumaAsegurada: {
        moneda: currencyPlan === "SOL" ? "PEN" : currencyPlan,
        monto: Number(sumAssured.valor)
      },
      atributos: {
        ...leadData.atributos,
        idPlan: typeOfFinancing.ideFinanciamiento,
      },
      finalizado: 2,
    };

    const isConditionsValid = validateConditions();
    if (!isConditionsValid) {
      dispatch(saveLeadData(leadToSend));
      sendLeads(leadToSend);
      const isCreditMaxAmount = Number(sumAssured?.value) > maxAmountQuote;
      const indValidacion = {
        ...(assuredFinancialEntity?.numId === 0 && { indOtherBank: true }),
        ...(isCreditMaxAmount && { indCreditMaxAmount: true }),
      };

      if (Object.keys(indValidacion).length > 0) {
        dispatch(changeIndValidacion(indValidacion));
      }

      return history.push(graciasValidacionStep);
    }

    const modalLoadingMessage = isSuscriptionEnabled ? "Responde las preguntas para continuar" : "Continuemos con el siguiente paso";
    setLoading(true);
    dispatch(showModalLoading(modalLoadingMessage));
    dispatch(saveLeadData(leadToSend));
    await sendLeads(leadToSend);
    await selectedPlanToService();

    const sumAssuredValue = sumAssured?.text.replace(/,/g, "");
    const tagChain = [
      {
        type: "getTagMetadata",
        key: `Cotización ${digitalDataProductName}`,
        value: `${sumAssuredValue} - ${savingTime?.text} años - ${returnPercentage?.text}`,
      },
      {
        type: "getTagMetadata",
        key: `Banco ${digitalDataProductName}`,
        value: `${assuredFinancialEntity?.name}`,
      },
      {
        type: "getTagMetadata",
        key: `Moneda ${digitalDataProductName}`,
        value: currencyPlan === "SOL" ? "Soles" : "Dólares",
      },
      {
        type: "getTagMetadata",
        key: `Frecuencia ${digitalDataProductName}`,
        value: `${typeOfFinancing?.frecuenciaPago}`,
      },
    ];
    sendTagChain(tagChain);
    if (isSuscriptionEnabled) return history.push(suscripcionStep);

    helpers.getTagVirtual(
      `sol:comprar:${productName}:loader-direccion`
    );

    if (state !== StateMachine[4]) {
      dispatch(showModalLoading(""));
      history.push(nextStep);
    }
  };

  const validateConditions = () =>
    !!assuredFinancialEntity &&
    assuredFinancialEntity.numId !== 0 &&
    Number(sumAssured.value) <= maxAmountQuote;

  const selectedPlanToService = async () => {
    const request = {
      ideFinanciamiento: typeOfFinancing.ideFinanciamiento,
      codigoProducto: CODE_VIDA_CT.PRODUCT,
      codigoAplicacion: CODE_VIDA_CT.APPLICATION,
      moneda: currencyPlan,
    };
    await selectQuoteVe(request);
    setLoading(false);
  };

  return (
    <FooterAction
      loading={loading}
      loadingAnimation={isLoadingData}
      disabled={isLoadingData}
      contentAdditional={<DetailPlanMobile callAnalyticsAction={analyticsDetailAction} />}
      onHandleClick={onHandleClick}
      classNameContent="footer-action-ve"
    />
  );
};
